var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 190,
    viewBox: "0 0 178 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178 0.503418H0V148.503L89 189.003L178 148.503V0.503418Z",
    fill: "#D5241A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7356 130.934H37.1587L36.4216 133.056H33L37.6978 120.858H41.1964L45.8943 133.056H42.4727L41.7356 130.934ZM40.8884 128.529L39.4472 124.47L38.0059 128.529H40.8884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.272 120.858H54.0468C55.18 120.858 56.0382 121.13 56.6323 121.663C57.2264 122.207 57.5124 122.98 57.5124 123.992C57.5124 124.612 57.4024 125.112 57.1824 125.526C56.9624 125.928 56.6213 126.277 56.1592 126.549C56.6213 126.636 57.0063 126.766 57.3254 126.941C57.6445 127.114 57.9085 127.332 58.1065 127.593C58.3046 127.854 58.4476 128.148 58.5356 128.464C58.6236 128.79 58.6676 129.139 58.6676 129.497C58.6676 130.074 58.5687 130.574 58.3706 131.021C58.1725 131.467 57.8865 131.837 57.5234 132.142C57.1604 132.446 56.7093 132.675 56.1922 132.816C55.6751 132.957 55.081 133.045 54.4209 133.045H49.272V120.858ZM52.4845 125.646H53.0786C54.0798 125.646 54.5859 125.254 54.5859 124.47C54.5859 123.687 54.0798 123.284 53.0786 123.284H52.4845V125.646ZM52.4845 130.597H53.1887C53.9918 130.597 54.5749 130.498 54.927 130.292C55.279 130.085 55.4551 129.759 55.4551 129.301C55.4551 128.844 55.279 128.518 54.927 128.311C54.5749 128.105 54.0028 128.007 53.1887 128.007H52.4845V130.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9446 130.934H65.3677L64.6306 133.056H61.209L65.8958 120.858H69.3944L74.0923 133.056H70.6707L69.9446 130.934ZM69.0864 128.529L67.6451 124.47L66.2038 128.529H69.0864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6826 125.57H85.3144V120.858H88.527V133.056H85.3144V128.029H80.6826V133.056H77.481V120.858H80.6826V125.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0708 133.056V120.858H100.123V123.545H96.2724V133.056H93.0708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.279 130.934H106.702L105.965 133.056H102.543L107.241 120.858H110.74L115.438 133.056H112.016L111.279 130.934ZM110.432 128.529L108.991 124.47L107.549 128.529H110.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.028 133.056H118.826V120.858H123.931C125.317 120.858 126.374 121.217 127.111 121.924C127.848 122.632 128.211 123.644 128.211 124.938C128.211 126.233 127.848 127.234 127.111 127.953C126.374 128.671 125.306 129.019 123.931 129.019H122.028V133.056ZM122.028 126.461H123.095C124.272 126.461 124.866 125.951 124.866 124.938C124.866 123.926 124.272 123.415 123.095 123.415H122.028V126.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.337 130.368C132.755 130.368 133.019 130.248 133.151 130.009C133.283 129.769 133.338 129.411 133.338 128.954V120.858H143.449V130.368H145V135.33H141.809V133.045H134.394V135.33H131.204V130.368H132.337ZM140.236 123.545H136.54V128.986C136.54 129.301 136.529 129.563 136.517 129.78C136.496 129.998 136.463 130.194 136.407 130.379H140.236V123.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4272 57.5364H47L55.8718 64.1989H71.1168L73.4272 57.5364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.129 75.0979L72.5708 76.7603L73.129 75.0979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.573 57.5364L106.876 64.1989H122.128L131 57.5364H104.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37 68.3198L110.024 73.32L116.502 68.3198H108.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5724 68.3198L67.9175 73.32L61.4404 68.3198H69.5724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.463 106.858L88.9968 27.5034L62.5371 106.858L72.6291 99.7651L88.9968 48.9611L105.092 99.5726L115.463 106.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6773 81.3689L89.1397 79.4048L86.3361 81.5101L82.7017 92.7877L89.1397 88.269L95.2987 92.5951L91.6773 81.3689Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 108,
    fill: "white",
    transform: "translate(33 27.5034)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLogo);
export default __webpack_public_path__ + "static/media/red-logo.058c3928.svg";
export { ForwardRef as ReactComponent };